"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateSessionId = exports.TRACKING_CLIENT_ID_COOKIE_CONFIG = exports.CLIENT_ID_COOKIE_CONFIG = exports.TRACKING_SESSION_ID_COOKIE_CONFIG = exports.SESSION_ID_COOKIE_CONFIG = void 0;
const secure_1 = require("@lukeed/uuid/secure");
function generateSessionId() {
    return secure_1.v4();
}
exports.generateSessionId = generateSessionId;
const SESSION_ID_COOKIE_CONFIG = {
    name: 'hsid',
    options: {
        sameSite: 'lax',
        httpOnly: true,
        secure: true,
        path: '/',
    },
};
exports.SESSION_ID_COOKIE_CONFIG = SESSION_ID_COOKIE_CONFIG;
const CLIENT_ID_COOKIE_CONFIG = {
    name: 'cid',
    options: {
        maxAge: 60 * 60 * 24 * 365 * 10,
        sameSite: 'lax',
        httpOnly: true,
        secure: true,
        path: '/',
    },
};
exports.CLIENT_ID_COOKIE_CONFIG = CLIENT_ID_COOKIE_CONFIG;
const TRACKING_SESSION_ID_COOKIE_CONFIG = {
    name: 'tsid',
    options: {
        sameSite: 'lax',
        secure: true,
        httpOnly: false,
        path: '/',
    },
};
exports.TRACKING_SESSION_ID_COOKIE_CONFIG = TRACKING_SESSION_ID_COOKIE_CONFIG;
const TRACKING_CLIENT_ID_COOKIE_CONFIG = {
    name: 'tcid',
    options: {
        maxAge: 60 * 60 * 24 * 365 * 10,
        sameSite: 'lax',
        secure: true,
        httpOnly: false,
        path: '/',
    },
};
exports.TRACKING_CLIENT_ID_COOKIE_CONFIG = TRACKING_CLIENT_ID_COOKIE_CONFIG;
//# sourceMappingURL=index.js.map